// Tipi di documento collaboratori: stessi codici del backend (documenti.service.ts).
// Il CUD lo carica solo lo staff; gli altri anche il collaboratore dal proprio portale.
export const TIPI_DOCUMENTO = {
  CUD:                'CUD',
  IDENTITA:           "Documento d'identità",
  CODICE_FISCALE:     'Codice fiscale / tessera sanitaria',
  CERTIFICATO_MEDICO: 'Certificato medico',
  QUALIFICA:          'Qualifica / brevetto',
  ALTRO:              'Altro',
};
export const TIPI_COLLABORATORE = ['IDENTITA', 'CODICE_FISCALE', 'CERTIFICATO_MEDICO', 'QUALIFICA', 'ALTRO'];
export const etichettaTipo = (tipo) => TIPI_DOCUMENTO[tipo] || tipo;
export const MAX_MB = 10;
export const ACCEPT = '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png';

// Nome del file scaricato = nome visualizzato + estensione reale (altrimenti sul telefono non si apre)
export const nomeDownload = (d) => {
  const ext = (d.file_nome || '').split('.').pop();
  return ext && !d.nome.toLowerCase().endsWith('.' + ext) ? `${d.nome}.${ext}` : d.nome;
};
